export default __webpack_public_path__ + "static/media/marquise.02a81713.webp";